import { React } from '@gasbuddy/react';
import { Modal } from '@gasbuddy/react-components';
import ReactMarkdown from 'react-markdown';

interface CategoryEntry {
  detail: string;
}
interface CategoryDetailProps {
  category: CategoryEntry;
  onClose: () => void;
}

export default function CategoryDetail({ category, onClose }: CategoryDetailProps) {
  return (
    <Modal
      content={<div style={{ minHeight: '80vh' }}><ReactMarkdown>{category.detail}</ReactMarkdown></div>}
      forceIsShowing
      onClose={onClose}
    />
  );
}
